"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedEntityTypes = void 0;
exports.allowedEntityTypes = ['merchant', 'business', 'partner', 'estore', 'platform'];
